export default function(html) {
  return ((new DOMParser().parseFromString(html || '', 'text/html')).body.textContent || '').replace(/\n/g, ' ').trim();
}
